module.exports = __webpack_public_path__ + "static/img/3.f504f9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/sp/3.png
// module id = Tx6p
// module chunks = 0